import Button from "components/_button/form/submit"
import Input from "components/input/input"
import REGEX from "constants/regex"
import { Dispatch, FC, FormEvent, SetStateAction, useCallback, useState } from "react"
import IProjectCreate from "rules/interface/project/create.interface"
import styles from "./index.module.scss"
import toEnglishDigits from "utils/persian-to-english-digit"
import ReactGA from 'react-ga'



interface IError {
    phoneNumber?: string
}


interface IProps {
    next: () => void
    values: IProjectCreate
    setValues: Dispatch<SetStateAction<IProjectCreate>>
}


const PhoneNumberStep: FC<IProps> = ({ next, values, setValues }) => {

    const [errors, setErrors] = useState<IError>({});

    // validate input's
    // have two state for handle validation
    // one of them for all fields can validate
    // another one for save error message of each input error
    const validationError = () => {
        let error: IError = {};
        // by default form validate is true
        // if we have one error or more
        // return false and waiting for fill data by client
        let formIsValid = true;

        if (typeof values?.user?.phoneNumber !== "undefined") {
            if (!values?.user?.phoneNumber.match(REGEX.PHONE_NUMBER)) {
                formIsValid = false;
                error["phoneNumber"] = "لطفا شماره‌تلفن صحیح وارد نمایید";
            }
        }
        if (!values?.user?.phoneNumber) {
            formIsValid = false;
            error["phoneNumber"] = "شماره‌تلفن خود را وارد کنید";
        }

        setErrors(error);
        return formIsValid;
    }

    const onSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        if (validationError()) {
            ReactGA.event({
                category: 'Submit',
                action: 'Click',
                label: 'submitForm3'
            });

            next()
        }
    }, [values])



    return (
        <article className="flex flex-column gap-15">
            <header>
                <h4 className={styles.title}>
                    برای استفاده از خدمات اقساطی سلام‌ساختمان فرم زیر را تکمیل کنید
                </h4>
            </header>

            <form onSubmit={onSubmit} className="flex flex-column gap-25">
                <section>
                    <Input
                        inputMode="numeric"
                        label="شماره همراه"
                        placeholder="شماره همراه خود را وارد کنید."
                        className={styles.input_text}
                        value={values?.user?.phoneNumber ?? ""}
                        validationMessage={errors?.phoneNumber ?? ""}
                        onChange={e => setValues(prev => ({
                            ...prev,
                            user: {
                                ...prev?.user ?? {},
                                phoneNumber: toEnglishDigits(e.target.value)
                            }
                        }))}
                    />
                </section>
                <Button type="submit" className="flex align-i-center jcc gap-10" id="form-submit">
                    مرحله بعدی
                    <svg width="8" height="16" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.00009 16.9201L1.48009 10.4001C0.710088 9.63008 0.710088 8.37008 1.48009 7.60008L8.00009 1.08008" stroke="#EEEEEE" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </Button>
            </form>
        </article>
    )
}

export default PhoneNumberStep